module.exports = __webpack_public_path__ + "static/media/ic_video_disable_small_transparent.b9c551af.svg";